<template>
  <PrintButtonBase
    cta="Tisknout pin"
    :linkHref="printUrl()"
    linkAlt="Vytisknout tento pin"
  />
</template>

<script>
import { SINGLE_PIN_PRINT_BASE_URL } from '@/constants/global';
import PrintButtonBase from './PrintButtonBase';

export default {
  props: {
    pinId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  },
  components: {
    PrintButtonBase
  },
  methods: {
    printUrl() {
      return `${SINGLE_PIN_PRINT_BASE_URL}${this.pinId}`;
    }
  }
};
</script>

<style scoped></style>
